<template>
  <div>

    <label
      v-if="!value"
      class="btn btn-primary"
      style="position: relative; overflow: hidden;">
      <Loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="false"
        :height="25" />
      Selecionar arquivo
      <input
        type="file"
        class="form-control"
        :disabled="loading"
        @change="uploadFile($event)"
        style="display: none;">
    </label>

    <div>
      <ValidateMessage
        :error="validateErrors" />
    </div>

    <div
      v-if="value"
      class="alert alert-primary file">
      <div class="d-flex">
        <div class="mr-auto">
          {{ value.title }}
        </div>
        <div class="ml-2 remove">
          <a
            href="javascript:void(0)"
            class="text-secondary"
            @click="removeFile">
            <i class="far fa-trash-alt"></i>
            </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import FileReader from '@/utils/FileReader'
import Loading from 'vue-loading-overlay'
import ValidateMessage from '../ValidateMessage'

export default {
  name: 'File',
  components: {
    Loading,
    ValidateMessage
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      validateErrors: null
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  created () {
  },
  methods: {
    removeFile () {
      this.$emit('input', null)
    },
    uploadFile (event) {
      this.loading = true

      const file = event.target.files[0]

      // FileReader(file)
      // .then((response) => {
      //   return this.$store.dispatch('createMedia', {
      //     'title': file.name,
      //     'base64': response
      //   })
      // })
      const formData = new FormData()
      formData.append('file', file)
      this.$store.dispatch('createMediaMultipart', formData)
      .then((response) => {
        this.loading = false
        this.$emit('input', response)
        this.validateErrors = null
      })
      .catch((err) => {
        this.loading = false
        this.validateErrors = {
          message: 'Erro ao enviar o arquivo. Certifique-se de que o arquivo é menor que 5mb.'
        }
        // if (err.response.data.name === 'ValidationError') {
          // this.validateErrors = err.response.data.errors
        // }
      })
    }
  }
}
</script>

<style scoped>
</style>
